export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              关于夜猫
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              深夜不孤单，银幕有温暖
            </p>
          </div>

          <div className="bg-background-100 rounded-xl border border-background-200/70 p-6 md:p-8">
            <div className="flex items-center justify-center mb-6">
              <div className="w-16 h-16 flex items-center justify-center bg-primary-500 rounded-2xl">
                <i className="ri-movie-2-line text-background-50 text-3xl"></i>
              </div>
            </div>

            <div className="text-center max-w-lg mx-auto">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                夜猫电影院诞生于一群资深夜猫子的共同愿望——在凌晨时分，找到一个不卡顿、片源全、更新快的线上深夜影院。我们从零开始搭建片库，精心筛选每一部上架作品，确保每一次深夜点击都能秒速播放。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                目前平台已覆盖动作、悬疑、科幻、爱情、喜剧、纪录等全类型超过两万部高清影视资源，每日凌晨准时更新，并持续根据夜猫子们的内容反馈优化片库。我们相信，每一个深夜都值得一部好片相伴。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                夜猫电影院 —— 为每一个不眠夜点亮银幕之光。
              </p>
            </div>

            <div className="mt-8 flex flex-wrap justify-center gap-6">
              <div className="text-center">
                <span className="block text-2xl font-bold text-primary-600 font-heading">20000+</span>
                <span className="text-xs text-foreground-500">高清片源</span>
              </div>
              <div className="text-center">
                <span className="block text-2xl font-bold text-accent-600 font-heading">50+</span>
                <span className="text-xs text-foreground-500">日更新量</span>
              </div>
              <div className="text-center">
                <span className="block text-2xl font-bold text-secondary-600 font-heading">99.9%</span>
                <span className="text-xs text-foreground-500">播放成功率</span>
              </div>
              <div className="text-center">
                <span className="block text-2xl font-bold text-primary-600 font-heading">7×24</span>
                <span className="text-xs text-foreground-500">全天候服务</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}